(function () {
  'use strict';

  if (window.__pcCustomDrawerInit) return;
  window.__pcCustomDrawerInit = true;

  let currentStep = 1;
  let currentVariantId = null;
  let currentProductId = null;
  let currentSessionId = null;
  let currentQuantity = 1;
  let productConfig = null;
  
  let formData = {
    photoOption: null,
    headstockPhoto: null,
    headstockPhotoDataURL: null,
    engravingOption: null,
    engravingText: '',
    customDesign: null,
    customDesignDataURL: null,
    whatsappNumber: '',
    currentStep: 1
  };

  // *** 辅助函数：控制2步流程的按钮状态 ***
  function updateTwoStepButtons(isYes) {
    const btnNext = document.getElementById('btn-next');
    const finalButtons = document.getElementById('final-buttons');
    
    if (!btnNext || !finalButtons) return;

    if (isYes) {
      // 选了 Yes (Add engraving) -> 显示 Next，隐藏 Checkout
      btnNext.classList.remove('hidden');
      finalButtons.classList.add('hidden');
    } else {
      // 选了 No (Without engraving) -> 隐藏 Next，显示 Checkout
      btnNext.classList.add('hidden');
      finalButtons.classList.remove('hidden');
    }
  }

  function loadSavedData() {
    try {
      const saved = localStorage.getItem('pcCustomDrawerData');
      if (saved) {
        const parsed = JSON.parse(saved);
        formData.photoOption = parsed.photoOption || null;
        formData.engravingOption = parsed.engravingOption || null;
        formData.engravingText = parsed.engravingText || '';
        formData.whatsappNumber = parsed.whatsappNumber || '';
        formData.currentStep = parsed.currentStep || 1;
        formData.headstockPhotoDataURL = parsed.headstockPhotoDataURL || null;
        formData.customDesignDataURL = parsed.customDesignDataURL || null;
        
        if (parsed.headstockPhotoDataURL) {
          dataURLtoFile(parsed.headstockPhotoDataURL, 'headstock.jpg').then(file => {
            formData.headstockPhoto = file;
          });
        }
        if (parsed.customDesignDataURL) {
          dataURLtoFile(parsed.customDesignDataURL, 'design.jpg').then(file => {
            formData.customDesign = file;
          });
        }
      }
    } catch (e) {
      console.warn('Failed to load saved data:', e);
    }
  }

  function saveData() {
    try {
      const dataToSave = {
        photoOption: formData.photoOption,
        engravingOption: formData.engravingOption,
        engravingText: formData.engravingText,
        whatsappNumber: formData.whatsappNumber,
        currentStep: currentStep,
        headstockPhotoDataURL: formData.headstockPhotoDataURL,
        customDesignDataURL: formData.customDesignDataURL,
        productId: currentProductId
      };
      localStorage.setItem('pcCustomDrawerData', JSON.stringify(dataToSave));
    } catch (e) {
      console.warn('Failed to save data:', e);
    }
  }

  function dataURLtoFile(dataurl, filename) {
    return fetch(dataurl)
      .then(res => res.blob())
      .then(blob => new File([blob], filename, { type: blob.type }));
  }

  function clearSavedData() {
    try {
      localStorage.removeItem('pcCustomDrawerData');
      formData = {
        photoOption: null,
        headstockPhoto: null,
        headstockPhotoDataURL: null,
        engravingOption: null,
        engravingText: '',
        customDesign: null,
        customDesignDataURL: null,
        whatsappNumber: '',
        currentStep: 1
      };
      currentStep = 1;
    } catch (e) {
      console.warn('Failed to clear data:', e);
    }
  }

  loadSavedData();

  const overlay = document.getElementById('custom-drawer-overlay');
  const drawer = document.getElementById('custom-drawer');
  const closeBtn = document.getElementById('drawer-close');
  const stepIndicator = document.getElementById('step-indicator-text');
  
  const buttonsContainer = document.getElementById('footer-buttons-container');
  const progressWrapper = document.getElementById('upload-progress-wrapper');
  const progressFill = document.getElementById('progress-fill');
  const progressText = document.getElementById('progress-text');

  const btnBack = document.getElementById('btn-back');
  const btnNext = document.getElementById('btn-next');
  const finalButtons = document.getElementById('final-buttons');
  const btnCheckout = document.getElementById('btn-checkout');

  function trackRealAddToCart(variantId) {
    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    if (typeof fbq !== 'undefined') fbq('track', 'AddToCart', { content_ids: [variantId], content_type: 'product', currency: currency, content_name: 'Customized Guitar Box' });
    if (typeof ttq !== 'undefined') ttq.track('AddToCart', { content_id: variantId, content_name: 'Customized Guitar Box' });
    if (typeof gtag !== 'undefined') gtag('event', 'add_to_cart', { items: [{ item_id: variantId }] });
  }

  function toggleUploadMode(isUploading) {
    if (isUploading) {
      buttonsContainer.style.display = 'none';
      progressWrapper.style.display = 'flex';
      updateProgress(0);
    } else {
      buttonsContainer.style.display = 'flex';
      progressWrapper.style.display = 'none';
    }
  }

  function updateProgress(percent) {
    progressFill.style.width = percent + '%';
    progressText.innerText = 'Uploading... ' + percent + '%';
  }

  function ajaxPostWithProgress(url, fd) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.responseType = 'json';
      if (xhr.upload) {
        xhr.upload.onprogress = function (e) {
          if (e.lengthComputable) {
            const percentComplete = Math.round((e.loaded / e.total) * 100);
            updateProgress(percentComplete);
          }
        };
      }
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) { 
          resolve(xhr.response); 
        } else { 
          reject(xhr.response || xhr.statusText); 
        }
      };
      xhr.onerror = function () { reject('Network error'); };
      xhr.send(fd);
    });
  }

  function buildPropsAndFiles() {
    const props = {};
    const files = {};
    if (!currentSessionId) currentSessionId = 'pc_' + Date.now() + '_' + Math.random().toString(16).slice(2);
    props['_pc_session'] = currentSessionId;
    props['_custom_product'] = 'true';

    const waInput = document.getElementById('whatsapp-input');
    if (waInput && waInput.value.trim() !== '') {
      props['WhatsApp Contact'] = waInput.value.trim();
    }

    // 只有3步流程才需要处理headstock photo
    if (productConfig && productConfig.steps === 3) {
      if (formData.photoOption === 'upload_now' && formData.headstockPhoto) {
        props['Headstock Photo'] = 'Uploaded';
        files['Headstock Photo Upload'] = formData.headstockPhoto;
      } else {
        props['Headstock Photo'] = 'Send later';
      }
    }

    if (formData.engravingOption === 'yes') {
      props['Engraving'] = (formData.engravingText || '').trim() || '(not provided)';
      if (formData.customDesign) {
        props['Custom Design'] = 'Uploaded';
        files['Custom Design Upload'] = formData.customDesign;
      }
    } else {
      props['Engraving'] = 'No';
    }
    return { props, files };
  }

  async function performAddToCart() {
    if (!currentVariantId) {
      throw new Error('Missing Variant ID');
    }
    const { props, files } = buildPropsAndFiles();
    const fd = new FormData();
    fd.append('id', String(currentVariantId));
    fd.append('quantity', String(currentQuantity || 1));

    Object.entries(props).forEach(([k,v]) => fd.append(`properties[${k}]`, String(v)));
    Object.entries(files).forEach(([k,file]) => fd.append(`properties[${k}]`, file, file.name));
    return await ajaxPostWithProgress('/cart/add.js', fd);
  }

  function closeDrawer(){
    saveData();
    drawer.classList.remove('open','title-moved');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updateUIForProduct() {
    if (!productConfig) return;

    const engravingImg = document.getElementById('engraving-guide-img');
    const lightboxImg = document.getElementById('lightbox-img');
    if (engravingImg && productConfig.engraving.guideImage) {
      const imgUrl = (window.shopifyAssetUrl || '') + productConfig.engraving.guideImage;
      engravingImg.src = imgUrl;
      if (lightboxImg) lightboxImg.src = imgUrl;
    }

    const engravingHint = document.querySelector('.engraving-hint');
if (engravingHint) {
  engravingHint.style.display = 'none';
}

    const totalSteps = productConfig.steps;
    if (stepIndicator) {
      stepIndicator.textContent = `${currentStep} of ${totalSteps}`;
    }

    const step1 = document.getElementById('step-1');
    if (step1) {
      step1.style.display = (productConfig.steps === 2) ? 'none' : 'block';
    }
  }

  window.openCustomDrawer = function(variantId, productId, sessionId, quantity) {
    if (window.event) { 
      window.event.preventDefault(); 
      window.event.stopPropagation(); 
    }
    
    if (!variantId) {
      alert('Missing Variant ID\n\nPlease refresh and try again.');
      return false;
    }
    
    currentVariantId = variantId;
    currentProductId = productId;
    currentSessionId = sessionId || ('pc_' + Date.now() + '_' + Math.random().toString(16).slice(2));
    currentQuantity = quantity || 1;
    
   // *** 获取产品配置 ***
// 只有 variantId 44137105195101 是 3 步流程，其他全部默认 2 步
const threeStepVariantId = '44137105195101';

if (String(variantId) === threeStepVariantId) {
  // 3 步产品：用 engraving-options.jpg
  productConfig = {
    steps: 3,
    engraving: {
      guideImage: 'engraving-options.jpg'
    }
  };
  console.log('✅ [Config] 3步流程，VariantID:', variantId);
} else {
  // 其他所有产品：2 步流程，刻字图用 {variantId}.jpg
  productConfig = {
    steps: 2,
    engraving: {
      guideImage: variantId + '.jpg'
    }
  };
  console.log('✅ [Config] 2步流程，VariantID:', variantId, '| 刻字图:', variantId + '.jpg');
}

    updateUIForProduct();
    restoreUI();
    
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => drawer.classList.add('title-moved'), 600);
    return false;
  };

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) {
        closeDrawer();
      }
    });
  }

  function getFirstStep() {
    return (productConfig && productConfig.steps === 2) ? 2 : 1;
  }

  function getLastStep() {
    return (productConfig && productConfig.steps === 2) ? 3 : 3;
  }

  function showStep(step){
    // 1. 清场
    ['step-1', 'step-2', 'step-3'].forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        el.style.display = 'none';
        el.classList.remove('active');
      }
    });

    // 2. 显示当前步骤
    const currentEl = document.getElementById('step-' + step);
    if (currentEl) {
      currentEl.style.display = 'block';
      setTimeout(() => {
        currentEl.classList.add('active');
      }, 10);
    }
    
    // 3. 更新步骤指示器
    const totalSteps = productConfig ? productConfig.steps : 3;
    let displayStepNum = step;
    if (productConfig && productConfig.steps === 2) {
        displayStepNum = (step === 2) ? 1 : 2;
    }
    if (stepIndicator) {
      stepIndicator.textContent = `${displayStepNum} of ${totalSteps}`;
    }
    
    // 4. Back 按钮显示逻辑
    const firstStep = getFirstStep();
    if (btnBack) {
       btnBack.classList.toggle('hidden', step === firstStep);
    }
    
    // 5. 按钮状态逻辑
    if (step === 3) {
      // Step 3 (确认页)：隐藏 Next，显示 Checkout
      if(btnNext) btnNext.classList.add('hidden');
      if(finalButtons) finalButtons.classList.remove('hidden');

      // *** 2步流程 vs 3步流程的 Step 3 显示内容 ***
      const uploadBlock = document.getElementById('step3-content-upload');
      const laterBlock = document.getElementById('step3-content-later');
      const headstockItem = document.getElementById('confirm-headstock-item');
      const engravingItem = document.getElementById('confirm-engraving-item');

      if (productConfig && productConfig.steps === 2) {
        // === 2步流程的 Step 3 ===
        // 始终显示 uploadBlock（包含 WhatsApp 输入）
        if(uploadBlock) uploadBlock.classList.remove('hidden');
        if(laterBlock) laterBlock.classList.add('hidden');
        
        // 隐藏 Headstock mockup，只显示 Engraving mockup
        if(headstockItem) headstockItem.style.display = 'none';
        if(engravingItem) engravingItem.style.display = 'list-item';
        
      } else {
        // === 3步流程的 Step 3 ===
        if (formData.photoOption === 'send_later') {
          if(uploadBlock) uploadBlock.classList.add('hidden');
          if(laterBlock) laterBlock.classList.remove('hidden');
        } else {
          if(uploadBlock) uploadBlock.classList.remove('hidden');
          if(laterBlock) laterBlock.classList.add('hidden');
          
          // 3步流程：显示 Headstock，根据选择显示/隐藏 Engraving
          if(headstockItem) headstockItem.style.display = 'list-item';
          if(engravingItem) {
            engravingItem.style.display = (formData.engravingOption === 'yes') ? 'list-item' : 'none';
          }
        }
      }

    } else {
      // 不是 Step 3
      if(btnNext) btnNext.classList.remove('hidden');
      if(finalButtons) finalButtons.classList.add('hidden');

      // *** 2步流程在 Step 2 时，检查是否选了 No ***
      if (step === 2 && productConfig && productConfig.steps === 2) {
        if (formData.engravingOption === 'no') {
          updateTwoStepButtons(false); // 显示 Checkout
        } else if (formData.engravingOption === 'yes') {
          updateTwoStepButtons(true);  // 显示 Next
        }
        // 如果还没选，默认显示 Next（由上面的代码处理）
      }
    }

    currentStep = step;
    saveData();
  }

  if (btnBack) {
    btnBack.addEventListener('click', () => {
      const firstStep = getFirstStep();
      if (currentStep > firstStep) {
        showStep(currentStep - 1);
      }
    });
  }
  
  if (btnNext) {
    btnNext.addEventListener('click', () => {
      if (validateStep(currentStep)) {
        showStep(Math.min(3, currentStep + 1));
      }
    });
  }

  function validateStep(step){
    if (step === 1 && productConfig && productConfig.steps === 3) {
      if (!formData.photoOption) {
        alert('Please choose an option for your headstock photo.');
        return false;
      }
      if (formData.photoOption === 'upload_now' && !formData.headstockPhoto) {
        alert('Please upload your headstock photo.');
        return false;
      }
    }
    if (step === 2) {
      if (!formData.engravingOption) {
        alert('Please choose an engraving option.');
        return false;
      }
    }
    return true;
  }

  // Step 1 监听 (仅3步流程)
  drawer.querySelectorAll('input[name="photo_option"]').forEach(radio => {
    radio.addEventListener('change', (e) => {
      formData.photoOption = e.target.value;
      const isUpload = e.target.value === 'upload_now';
      document.getElementById('upload-section-1').classList.toggle('hidden', !isUpload);
      saveData();
      if (!isUpload) {
        setTimeout(() => { showStep(2); }, 300);
      }
    });
  });

  // Step 2 监听 (核心修改部分)
  drawer.querySelectorAll('input[name="engraving_option"]').forEach(radio => {
    radio.addEventListener('change', (e) => {
      formData.engravingOption = e.target.value;
      const isYes = e.target.value === 'yes';
      
      // UI: 显示/隐藏刻字输入框
      document.getElementById('engraving-section').classList.toggle('hidden', !isYes);
      saveData();
      
      // 逻辑分岔
      if (productConfig && productConfig.steps === 2) {
        // === 2步产品逻辑 ===
        // 选 Yes -> 显示 Next 按钮
        // 选 No  -> 显示 Checkout 按钮（不自动跳转！）
        updateTwoStepButtons(isYes);
        
      } else {
        // === 3步产品逻辑 ===
        // 选 No -> 自动跳到 Step 3
        if (!isYes) {
          setTimeout(() => { showStep(3); }, 300);
        }
      }
    });
  });

  const engInput = document.getElementById('engraving-text');
  if (engInput) {
    engInput.addEventListener('input', (e) => { 
      formData.engravingText = e.target.value; 
      saveData();
    });
  }

  const waInput = document.getElementById('whatsapp-input');
  if (waInput) {
    waInput.addEventListener('input', (e) => { 
      formData.whatsappNumber = e.target.value; 
      saveData();
    });
  }

  const zoomBtn = document.getElementById('zoom-trigger-btn');
  const lightbox = document.getElementById('engraving-lightbox');
  const lightboxClose = document.getElementById('lightbox-close');
  const lightboxImg = document.getElementById('lightbox-img');
  const sourceImg = document.getElementById('engraving-guide-img');
  const gestureArea = document.getElementById('lightbox-gesture-area');
  const imgWrapper = document.getElementById('lightbox-image-wrapper');
  if (zoomBtn && lightbox && lightboxImg && sourceImg && gestureArea && imgWrapper) {
    let state = { scale: 1, panning: false, pointX: 0, pointY: 0, startX: 0, startY: 0 };
    function resetZoom() { state = { scale: 1, panning: false, pointX: 0, pointY: 0, startX: 0, startY: 0 }; updateTransform(); }
    function updateTransform() { imgWrapper.style.transform = `translate(${state.pointX}px, ${state.pointY}px) scale(${state.scale})`; }
    zoomBtn.addEventListener('click', () => { lightboxImg.src = sourceImg.src; lightbox.classList.add('open'); document.body.style.overflow = 'hidden'; resetZoom(); });
    function closeLightbox() { lightbox.classList.remove('open'); if (!drawer.classList.contains('open')) document.body.style.overflow = ''; else document.body.style.overflow = 'hidden'; setTimeout(resetZoom, 300); }
    if(lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    let touchStartDist = 0, startScale = 1, lastTapTime = 0;
    gestureArea.addEventListener('touchstart', (e) => { const currentTime = new Date().getTime(); const tapLength = currentTime - lastTapTime; if (tapLength < 300 && tapLength > 0) { e.preventDefault(); if (state.scale > 1) resetZoom(); else { state.scale = 2.5; updateTransform(); } } lastTapTime = currentTime; if (e.touches.length === 2) { e.preventDefault(); touchStartDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); startScale = state.scale; } else if (e.touches.length === 1 && state.scale > 1) { state.panning = true; state.startX = e.touches[0].clientX - state.pointX; state.startY = e.touches[0].clientY - state.pointY; } }, { passive: false });
    gestureArea.addEventListener('touchmove', (e) => { e.preventDefault(); if (e.touches.length === 2) { const dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY); let newScale = startScale * (dist / touchStartDist); state.scale = Math.min(Math.max(1, newScale), 4); updateTransform(); } else if (e.touches.length === 1 && state.panning && state.scale > 1) { state.pointX = e.touches[0].clientX - state.startX; state.pointY = e.touches[0].clientY - state.startY; updateTransform(); } }, { passive: false });
    gestureArea.addEventListener('touchend', (e) => { state.panning = false; if (state.scale < 1) { state.scale = 1; state.pointX = 0; state.pointY = 0; imgWrapper.style.transition = 'transform 0.3s ease'; updateTransform(); setTimeout(() => { imgWrapper.style.transition = ''; }, 300); } });
    lightbox.addEventListener('click', (e) => { if ((e.target === lightbox || e.target === gestureArea) && state.scale === 1) closeLightbox(); });
  }

  setupFileUpload('headstock-file', 'photo-upload-area', 'photo-placeholder', 'photo-preview', 'photo-preview-img', 'photo-remove', 'headstockPhoto');
  setupFileUpload('design-file', 'design-upload-area', 'design-placeholder', 'design-preview', 'design-preview-img', 'design-remove', 'customDesign');
  
  function setupFileUpload(inputId, areaId, placeholderId, previewId, imgId, removeId, fileKey){
    const input = document.getElementById(inputId);
    const area = document.getElementById(areaId);
    const placeholder = document.getElementById(placeholderId);
    const preview = document.getElementById(previewId);
    const img = document.getElementById(imgId);
    const removeBtn = document.getElementById(removeId);
    if (!input || !area || !placeholder || !preview || !img || !removeBtn) return;
    
    area.addEventListener('click', (e) => { if (e.target !== removeBtn && !removeBtn.contains(e.target)) input.click(); });
    input.addEventListener('change', (e) => { if (e.target.files.length) handleFile(e.target.files[0]); });
    area.addEventListener('dragover', (e) => { e.preventDefault(); area.classList.add('drag-over'); });
    area.addEventListener('dragleave', () => area.classList.remove('drag-over'));
    area.addEventListener('drop', (e) => { e.preventDefault(); area.classList.remove('drag-over'); if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]); });
    removeBtn.addEventListener('click', (e) => { 
      e.stopPropagation(); 
      formData[fileKey] = null; 
      if (fileKey === 'headstockPhoto') formData.headstockPhotoDataURL = null;
      if (fileKey === 'customDesign') formData.customDesignDataURL = null;
      input.value = ''; 
      img.src = ''; 
      preview.classList.add('hidden'); 
      placeholder.classList.remove('hidden'); 
      area.classList.remove('has-preview'); 
      saveData();
    });
    
    function handleFile(file){ 
      if (!file.type.startsWith('image/')) { alert('Please upload an image file.'); return; } 
      if (file.size > 10 * 1024 * 1024) { alert('File too large. Max 10MB.'); return; } 
      
      formData[fileKey] = file; 
      const reader = new FileReader(); 
      reader.onload = (ev) => { 
        img.src = ev.target.result; 
        if (fileKey === 'headstockPhoto') formData.headstockPhotoDataURL = ev.target.result;
        if (fileKey === 'customDesign') formData.customDesignDataURL = ev.target.result;
        placeholder.classList.add('hidden'); 
        preview.classList.remove('hidden'); 
        area.classList.add('has-preview'); 
        saveData();
      }; 
      reader.readAsDataURL(file); 
    }
  }

  if (btnCheckout) {
    btnCheckout.addEventListener('click', async () => {
      toggleUploadMode(true);
      try { 
        await performAddToCart(); 
        trackRealAddToCart(currentVariantId); 
        clearSavedData();
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
      } 
      catch (e) { 
        console.error(e); 
        let msg = 'Sorry, we could not add the item to cart.';
        if (e && e.description) msg = e.description; 
        else if (e && e.message) msg = e.message;
        alert(msg + '\n\nPlease refresh and try again.'); 
        toggleUploadMode(false); 
      }
    });
  }

  function restoreUI() {
    // 重置 engraving option 的选中状态
    if (formData.photoOption) {
      const photoRadio = drawer.querySelector(`input[name="photo_option"][value="${formData.photoOption}"]`);
      if (photoRadio) {
        photoRadio.checked = true;
        const isUpload = formData.photoOption === 'upload_now';
        document.getElementById('upload-section-1').classList.toggle('hidden', !isUpload);
      }
    }

    if (formData.engravingOption) {
      const engRadio = drawer.querySelector(`input[name="engraving_option"][value="${formData.engravingOption}"]`);
      if (engRadio) {
        engRadio.checked = true;
        const isYes = formData.engravingOption === 'yes';
        document.getElementById('engraving-section').classList.toggle('hidden', !isYes);
      }
    }

    const engTextInput = document.getElementById('engraving-text');
    if (engTextInput) {
      engTextInput.value = formData.engravingText || '';
    }

    const waInputRestore = document.getElementById('whatsapp-input');
    if (waInputRestore) {
      waInputRestore.value = formData.whatsappNumber || '';
    }

    if (formData.headstockPhotoDataURL) {
      const pImg = document.getElementById('photo-preview-img');
      const pPrev = document.getElementById('photo-preview');
      const pHolder = document.getElementById('photo-placeholder');
      const pArea = document.getElementById('photo-upload-area');
      if (pImg && pPrev && pHolder && pArea) {
        pImg.src = formData.headstockPhotoDataURL;
        pHolder.classList.add('hidden');
        pPrev.classList.remove('hidden');
        pArea.classList.add('has-preview');
      }
    }

    if (formData.customDesignDataURL) {
      const dImg = document.getElementById('design-preview-img');
      const dPrev = document.getElementById('design-preview');
      const dHolder = document.getElementById('design-placeholder');
      const dArea = document.getElementById('design-upload-area');
      if (dImg && dPrev && dHolder && dArea) {
        dImg.src = formData.customDesignDataURL;
        dHolder.classList.add('hidden');
        dPrev.classList.remove('hidden');
        dArea.classList.add('has-preview');
      }
    }

    const savedStep = getFirstStep();
    btnBack.classList.toggle('hidden', savedStep === getFirstStep());
    btnNext.classList.toggle('hidden', savedStep === 3);
    finalButtons.classList.toggle('hidden', savedStep !== 3);
    toggleUploadMode(false);
    showStep(savedStep);
  }

  // *** Reset 按钮逻辑 ***
  const btnReset = document.getElementById('btn-reset');
  if (btnReset) {
    btnReset.addEventListener('click', function() {
      if (!confirm('Are you sure you want to clear all photos and text?')) return;

      document.querySelectorAll('#custom-drawer input[type="text"], #custom-drawer input[type="file"]').forEach(input => {
        input.value = '';
      });
      document.querySelectorAll('#custom-drawer input[type="radio"], #custom-drawer input[type="checkbox"]').forEach(input => {
        input.checked = false;
      });

      formData = {
        photoOption: null,
        headstockPhoto: null,
        headstockPhotoDataURL: null,
        engravingOption: null,
        engravingText: '',
        customDesign: null,
        customDesignDataURL: null,
        whatsappNumber: '',
        currentStep: 1
      };

      clearSavedData();

      const sectionsToHide = ['upload-section-1', 'engraving-section', 'photo-preview', 'design-preview'];
      sectionsToHide.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.classList.add('hidden');
      });

      const placeholdersToShow = ['photo-placeholder', 'design-placeholder'];
      placeholdersToShow.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.classList.remove('hidden');
      });

      const areasToReset = ['photo-upload-area', 'design-upload-area'];
      areasToReset.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.classList.remove('has-preview');
      });
      
      const imgsToClear = ['photo-preview-img', 'design-preview-img'];
      imgsToClear.forEach(id => {
        const el = document.getElementById(id);
        if(el) el.src = '';
      });

      // 重置按钮状态（2步流程恢复 Next）
      if (productConfig && productConfig.steps === 2) {
        if(btnNext) btnNext.classList.remove('hidden');
        if(finalButtons) finalButtons.classList.add('hidden');
      }

      const startStep = (productConfig && productConfig.steps === 2) ? 2 : 1;
      showStep(startStep);
      
      const drawerContent = document.querySelector('.drawer-content');
      if(drawerContent) drawerContent.scrollTop = 0;
    });
  }

  console.log('Custom drawer initialized with 2-step/3-step support');
})();